<template>
  <div>
    <Modal footer-hide v-model="show" width="428">
      <div class="r-preview-img">
        <img class="img" @error="imgError" v-if="pictureShow" :src="previewMsg.imagePath" alt="" />
        <div v-if="!pictureShow" class="img-none-box">
          <img class="img-none"  src="../assets/images/f-none.png" alt="" />
          <div class="img-none-font">{{$t('nOFabric')}}</div>
        </div>
        <div class="close common-hover" @click="close">
          <Icon type="ios-close-circle-outline" />
        </div>
        <div class="message">
          <div class="common-flex common-justify-between message-title">
            <div class="code">{{previewMsg.fabricCode}} <label class="stock" v-if="ck">( {{ck}} )</label></div>
            <div class="common-flex common-align-center" style="color: red;">
              {{ previewMsg.price }}
              <!-- {{previewMsg.fabricProName}} -->
            </div>
          </div>
          <div class="common-flex common-align-center">
            <div class="msg-item" :class="index<msg.length-1?'msg-item-border':''" v-for="(item, index) in msg" :key="index">
              <div class="label">{{ item.content? item.content:'-'}}</div>
              <div class="content">{{ item.label }}</div>
            </div>
          </div>
          <div class="common-flex">
            <div class="msg-item msg-item-border" style="margin-top:5px;width: 104px;">
              <div class="label">{{previewMsg.weight?previewMsg.weight:'-'}}</div>
              <div class="content">{{$t("fabricLibrary.weight")}}</div>
            </div>
            <div class="msg-item" style="flex:1;margin-top:5px">
              <div class="label" style="line-height: 31px;text-decoration: underline">{{previewMsg.remark}}</div>
              <!-- <div class="label" style="font-weight: 550;">{{previewMsg.remark}}</div> -->
              <!-- <div class="content">{{$t('styleOrdering.remark')}}</div> -->
            </div>
          </div>
        </div>
        <div v-if="quickIcon" class="left common-hover" @click="pro"><Icon type="ios-arrow-back" /></div>
        <div v-if="quickIcon" class="right common-hover" @click="next"><Icon type="ios-arrow-forward" /></div>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "r-preview-img",
  data() {
    return {
      pictureShow:true,
      show: true,
      msg: [
        {
          label: this.$t("fabricLibrary.color"),
          content: "",
        },
        {
          label: this.$t("fabricLibrary.FlowerType"),
          content: "",
        },
        {
          label: this.$t("fabricLibrary.yarnWeaving"),
          content: "",
        },
        // {
        //   label: this.$t("fabricLibrary.weight"),
        //   content: "",
        // },
        {
          label: this.$t("fabricLibrary.ingredient"),
          content: "",
        },
      ],
    };
  },
  watch: {
    previewShow: {
      handler(newval, oldval) {
        this.show = newval;
      },
      immediate: true,
    },

    show: {
      handler(newval, oldval) {
        if (newval == false) {
          this.$emit("handlerPreviewShow", newval);
        }
      },
      immediate: true,
    },
    previewMsg: {
       // 图片报错置空
      handler(newval, oldval) {
        this.pictureShow = true
        if(newval){
          console.log(newval)
          this.msg[0].content = newval.colorTypeName
          this.msg[1].content = (newval.flowerPatternName+' '+newval.flowerRemark)
          this.msg[2].content = newval.soledad
          // this.msg[3].content = newval.weight
          this.msg[3].content = newval.fabricProName
        }
      },
      immediate: true,
      deep:true
    },

  },
  props: {
    previewShow: Boolean,
    previewMsg:[Object,String],
    ck:String,
    previewIndex:[String,Number],
    quickIcon:{
      type:Boolean,
      default:true
    },
  },
  methods:{
    // 关闭预览
    close(){
      this.show = false
    },
    imgError(e) {
      this.pictureShow = false
    },
    // 上一个
    pro(){
      this.$emit('pro',this.previewIndex)
    },
    // 下一个
    next(){
      this.$emit('next',this.previewIndex)
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
/deep/.ivu-modal-close {
  display: none;
}
/deep/.ivu-modal-body {
  padding: 0;
}
.r-preview-img {
  width: 428px;
  height: 428px;
  position: relative;
  background: #d7d7d7;
  border-radius: 6px;
  // overflow: hidden;
  .left {
    position: absolute;
    top: 0;
    bottom: 0;
    margin-top: auto;
    margin-bottom: auto;
    left: -70px;
    font-size: 40px;
    color: #fff;
    width: 40px;
    height: 40px;
    line-height: 40px;
    border-radius: 50%;
    font-weight: 400;
    background: rgba(255, 255, 255, 0.14);
  }
  .right {
    position: absolute;
    top: 0;
    bottom: 0;
    margin-top: auto;
    margin-bottom: auto;
    right: -70px;
    color: #fff;
    font-size: 40px;
    width: 40px;
    line-height: 40px;
    height: 40px;
    border-radius: 50%;
    font-weight: 400;
    background: rgba(255, 255, 255, 0.14);
  }
  .message {
    width: 416px;
    height: 140px;
    background: rgba(255, 255, 255, 0.86);
    border-radius: 4px;
    position: absolute;
    bottom: 6px;
    left: 0;
    right: 0;
    margin-right: auto;
    margin-left: auto;
    padding: 20px 0 14px;
    .message-title{
      padding: 0 20px;
      margin-bottom: 20px;
    }
    .msg-item {
      width: 107px;
      position: relative;
      .label {
        font-size: 14px;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: center;
        color: #081938;
        line-height: 20px;
        letter-spacing: 1px;
      }
      .content {
        transform: scale(0.83);
        font-size: 12px;
        font-family: ArialMT;
        text-align: center;
        color: #081938;
        line-height: 11px;
        letter-spacing: 1px;
      }
    }
    .msg-item-border{
      position: relative;
    }
    .msg-item-border::after{
      content: "";
      width: 1px;
      height: 20px;
      background-color: rgba(0,56,136,0.1);
      position: absolute;
      right: 0;
      top: 0;
      bottom:0;
      margin-top: auto;
      margin-bottom: auto;
    }
    .code {
      font-size: 20px;
      font-weight: 700;
      text-align: left;
      color: #081938;
      line-height: 24px;
    }
    .stock {
      font-size: 14px;
      font-weight: 500;
      text-align: center;
      color: #0c750e;
      line-height: 20px;
      span {
        width: 4px;
        height: 4px;
        border-radius: 50%;
        margin-right: 8px;
        background: #0c750e;
      }
    }
  }
  .img {
    width: 428px;
    height: 428px;
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 6px;
  }
  .img-none{
    width: 120px;
    height: 120px;
    // margin: 80px auto 15px;
  }
  .img-none-font{
    font-size: 16px;
font-family: Roboto, Roboto-Regular;
font-weight: 400;
text-align: center;
color: #666666;
line-height: 19px;
  }
  .img-none-box{
    position: absolute;
    top: 80px;
    left:0;
    text-align: center;

    right: 0;
    margin-left: auto;
    margin-right: auto;
    display: block;

  }
  .close {
    font-size: 24px;
    color: rgba(255, 255, 255, 0.8);
    position: absolute;
    top: 8px;
    right: 8px;
    width: 24px;
    height: 24px;
    line-height: 24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/r-preview-img.vue